import React, { useEffect, useState } from "react";
import { DayofIcon, FishPurpleIcon } from "../components";
import { Skeleton } from "../components/ui/skeleton";
import { Link } from "react-router-dom";

const HtmlRenderer = ({ htmlContent }) => {
  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

const getDisciplineIconSrc = (discipline) =>
  `/media/images/discipline_${discipline}.svg`;

const getIconByTag = (tag) => {
  switch (tag?.toLowerCase()) {
    case "holyday":
      return (
        <img
          src={`${process.env.PUBLIC_URL}/media/images/discipline_fast.svg`}
          alt="Holyday"
          className="w-[72px] h-[72px]"
        />
      );
    case "fast":
      return (
        <img
          src={`${process.env.PUBLIC_URL}/media/images/discipline_abstain.svg`}
          alt="Fast"
          className="w-[72px] h-[72px]"
        />
      );
    case "abstain":
      return (
        <img
          src={`${process.env.PUBLIC_URL}/media/images/discipline_holyday.svg`}
          alt="Abstain"
          className="w-[72px] h-[72px]"
        />
      );
    default:
      return <FishPurpleIcon className="text-gold-600 w-[72px] h-[72px]" />;
  }
};

const DayBar = ({
  date,
  title,
  description,
  disciplines = [],
  tag,
  isLoading,
  hideIcon = false,
}) => {
  return (
    <div className={`mb-6 flex flex-row`}>
      {/* Icon Placeholder */}
      {!hideIcon &&
        (isLoading ? (
          <Skeleton className="h-[72px] w-[72px] rounded-md" />
        ) : (
          <DayofIcon className="text-gold-600" />
        ))}

      <div className="flex flex-col max-w-2xl pl-4">
        {/* Date Placeholder */}
        {isLoading ? (
          <Skeleton className="h-4 mb-2 rounded-md w-36" />
        ) : (
          date && (
            <p className="text-base text-left font-normal text-gray-500 font-redhat leading-6.5">
              {date}
            </p>
          )
        )}

        {/* Title & Tag Placeholder */}
        <div className="mt-1 flex flex-wrap items-center gap-2">
          {isLoading ? (
            <Skeleton className="h-8 rounded-md w-60" />
          ) : (
            title && (
              <>
                <h5 className="text-2xl font-bold leading-6 text-gray-900 underline font-cmr">
                  <Link to="/single-day">{title}</Link>
                </h5>
                {disciplines.length > 0 && (
                  <div className="mt-1 flex flex-wrap items-center gap-2 ml-4 text-purple-500">
                    {disciplines.map((d, i) => (
                      <img
                        key={i}
                        src={getDisciplineIconSrc(d)}
                        alt={d}
                        title={d.charAt(0).toUpperCase() + d.slice(1)}
                        className="w-5 h-5"
                      />
                    ))}
                  </div>
                )}
                <div className="mt-1 flex flex-wrap items-center gap-2">
                  <p className="text-sm font-medium leading-5 text-purple-500 ml-1.5">{tag}</p>
                </div>
              </>
            )
          )}
        </div>

        {/* Description Placeholder */}
        <div className="mt-1 max-w-[536px]">
          {isLoading ? (
            <Skeleton className="h-2 w-[400px] rounded-md" />
          ) : (
            description && (
              <div className="text-xs font-normal leading-4 text-left text-gray-600">
                <HtmlRenderer htmlContent={description} />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default DayBar;
